import { createStyles, makeStyles, SvgIconTypeMap, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        head: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            justifyContent: 'space-between',
            width: '100%',
        },
        headLeft: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            flex: 1,
            minWidth: 0,
        },
        headRight: {
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            width: '32px',
            height: '32px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontSize: '16px',
        },
        title: {
            fontSize: '12px',
            letterSpacing: '0.07em',
            textTransform: 'uppercase' as const,
            fontWeight: 600,
            marginBottom: '3px',
        },
        description: {
            fontSize: '13px',
            color: theme.palette.text.secondary,
            lineHeight: 1.5,
        },
    }),
);

interface SectionHeadingProps {
    title: string;
    description?: string;
    color?: string;
    bgColor?: string;
    icon?: OverridableComponent<SvgIconTypeMap>;
    headerAction?: React.ReactNode;
}

export function SectionHeading(props: SectionHeadingProps) {

    const classes = useStyles();

    return (
        <div className={classes.head}>
            <div className={classes.headLeft} style={{ alignItems: props.description ? 'flex-start' : 'center' }}>
                {props.icon ? (
                    <div
                        className={classes.icon}
                        style={{
                            backgroundColor: props.bgColor ?? '#e0e0e0',
                            color: props.color ?? '#000'
                        }}
                    >
                        <props.icon
                            fontSize="small"
                        />
                    </div>
                ) : null}
                <div>
                    <Typography
                        className={classes.title}
                        style={{ color: props.color ?? '#000', marginBottom: props.description ? 3 : 0 }}
                    >
                        {props.title}
                    </Typography>
                    {props.description && (
                        <Typography className={classes.description}>
                            {props.description}
                        </Typography>
                    )}
                </div>
            </div>
            {props.headerAction && (
                <div className={classes.headRight}>
                    {props.headerAction}
                </div>
            )}
        </div>
    );
};
